import { injectBaseConstantMethods } from "./BaseConstants";

export const USER_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    UNVERIFIED: "UNVERIFIED"
};

const displayTextKeys = {
    [USER_STATUS.ACTIVE]: "Active",
    [USER_STATUS.INACTIVE]: "Inactive",
    [USER_STATUS.UNVERIFIED]: "Active"
};

const labelClass = {
    [USER_STATUS.ACTIVE]: "cs-badge-active",
    [USER_STATUS.INACTIVE]: "cs-badge-inactive",
    [USER_STATUS.UNVERIFIED]: "cs-badge-active"
};

export default injectBaseConstantMethods(USER_STATUS, displayTextKeys, labelClass);
